<template>
  <div class="step-edit">
    <van-form @submit="onSubmit">
      <van-field
        v-model="step.content"
        name="content"
        label="步骤内容"
        type="textarea"
        placeholder="请输入步骤内容"
        :rules="[{ required: true, message: '请填写步骤内容' }]"
      />
      
      <van-field name="order" label="步骤顺序">
        <template #input>
          <van-stepper v-model="step.order" min="1" />
        </template>
      </van-field>

      <van-field name="reminder" label="提醒时间">
        <template #input>
          <van-switch v-model="hasReminder" @change="onReminderChange" />
        </template>
      </van-field>

      <van-popup v-model:show="showTimePicker" position="bottom">
        <van-datetime-picker
          v-model="reminderTime"
          type="datetime"
          title="选择提醒时间"
          :min-date="minDate"
          @confirm="onTimeConfirm"
          @cancel="showTimePicker = false"
        />
      </van-popup>

      <van-field
        v-if="hasReminder"
        v-model="formattedReminderTime"
        name="reminderTime"
        label="提醒时间"
        readonly
        @click="showTimePicker = true"
      />

      <div class="submit-btn">
        <van-button round block type="primary" native-type="submit">
          保存
        </van-button>
      </div>
    </van-form>

    <van-button 
      v-if="isEdit" 
      round 
      block 
      type="danger" 
      class="delete-btn"
      @click="showDeleteConfirm"
    >
      删除步骤
    </van-button>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showToast, showDialog } from 'vant'
import AV from 'leancloud-storage'
import dayjs from 'dayjs'

export default {
  name: 'StepEdit',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const isEdit = computed(() => !!route.params.id)
    
    const step = ref({
      content: '',
      order: 1,
      reminder: null
    })
    
    const hasReminder = ref(false)
    const showTimePicker = ref(false)
    const reminderTime = ref(new Date())
    const minDate = new Date()

    const formattedReminderTime = computed(() => {
      return step.value.reminder 
        ? dayjs(step.value.reminder).format('YYYY-MM-DD HH:mm')
        : ''
    })

    const loadStep = async () => {
      if (!isEdit.value) return

      const query = new AV.Query('Step')
      try {
        const stepObj = await query.get(route.params.id)
        step.value = {
          content: stepObj.get('content'),
          order: stepObj.get('order'),
          reminder: stepObj.get('reminder')
        }
        hasReminder.value = !!step.value.reminder
        if (hasReminder.value) {
          reminderTime.value = new Date(step.value.reminder)
        }
      } catch (error) {
        showToast('加载失败')
      }
    }

    const onReminderChange = (value) => {
      if (value) {
        showTimePicker.value = true
      } else {
        step.value.reminder = null
      }
    }

    const onTimeConfirm = (time) => {
      step.value.reminder = time
      showTimePicker.value = false
    }

    const onSubmit = async () => {
      const Step = AV.Object.extend('Step')
      const stepObj = isEdit.value ? await new AV.Query('Step').get(route.params.id) : new Step()

      stepObj.set('content', step.value.content)
      stepObj.set('order', step.value.order)
      stepObj.set('reminder', step.value.reminder)
      stepObj.set('user', AV.User.current())

      try {
        await stepObj.save()
        showToast('保存成功')
        router.back()
      } catch (error) {
        showToast('保存失败')
      }
    }

    const showDeleteConfirm = () => {
      showDialog({
        title: '确认删除',
        message: '是否确认删除该步骤？',
        showCancelButton: true,
      }).then(() => {
        deleteStep()
      })
    }

    const deleteStep = async () => {
      if (!isEdit.value) return

      try {
        const stepObj = AV.Object.createWithoutData('Step', route.params.id)
        await stepObj.destroy()
        showToast('删除成功')
        router.back()
      } catch (error) {
        showToast('删除失败')
      }
    }

    onMounted(loadStep)

    return {
      step,
      isEdit,
      hasReminder,
      showTimePicker,
      reminderTime,
      minDate,
      formattedReminderTime,
      onReminderChange,
      onTimeConfirm,
      onSubmit,
      showDeleteConfirm
    }
  }
}
</script>

<style scoped>
.step-edit {
  padding: 20px;
}
.submit-btn {
  margin: 16px 0;
}
.delete-btn {
  margin-top: 32px;
}
</style> 